import { gql } from "@shane32/graphql";
import { ShoppingCartPartialQuery, IShoppingCart } from "../queries/ShoppingCartQuery";

export const SaveForLaterProductMutation = gql`mutation($shoppingCartItemId:ID!) {
  v1 {
    cart {
      saveForLater(shoppingCartItemId: $shoppingCartItemId) ${ShoppingCartPartialQuery()}
    }
  }
}`;

export interface ISaveForLaterProductResult {
  v1: {
    cart: {
      saveForLater: IShoppingCart;
    };
  };
}

export interface ISaveForLaterProductVariables {
  shoppingCartItemId: string;
}
